import { Component, type ReactNode } from "react";

import type { ConsentType } from "src/api/types";
import { logPdf } from "src/lib/pdfLog";

export function ConsentPdfLoading() {
  return (
    <div role="status" className="consent-pdf-loading">
      <span className="consent-pdf-spinner" aria-hidden="true" />
      Loading document…
    </div>
  );
}

export function ConsentPdfError() {
  return (
    <div role="alert" className="status-alert status-alert--warning insurance-error">
      <p>Unable to load this document. Please try again in a moment.</p>
    </div>
  );
}

interface Props {
  consentType: ConsentType;
  children: ReactNode;
}

interface State {
  failed: boolean;
}

export class ConsentPdfBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(error: Error): void {
    logPdf("failure", { consentType: this.props.consentType, error: error.message });
  }

  render() {
    return this.state.failed ? <ConsentPdfError /> : this.props.children;
  }
}
